import React, {useState} from "react";
import {ConstraintPluginProps} from "../ConstraintDataPlugin";
import {RegExConstraintDataDto} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";
import {Grid, InputAdornment} from "@mui/material";
import TextField from "../../../../../../components/fields/textfield/TextField";
import {Cancel, CheckCircle, HelpOutline, PlayCircle} from "@mui/icons-material";
import {TooltippedIconButton} from "../../../../../../components/button/TooltippedIconButton";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {t} from "../../../../../../store/localization/TranslMessasge";

export function RegExConstraintPluginForm({data, onChange, errors}: Readonly<ConstraintPluginProps<RegExConstraintDataDto>>) {
    const [testValue, setTestValue] = useState('');
    const [testResult, setTestResult] = useState<{ valid: boolean; message: string } | null>(null);

    function onPatternChange(pattern: string) {
        onChange({
            ...data,
            regEx: pattern
        });
        setTestResult(null);
    }

    function onTestValueChange(value: string) {
        setTestValue(value);
        setTestResult(null);
    }

    function testPattern() {
        if (!data.regEx) {
            setTestResult({valid: false, message: t(DataTypeTranslationKey.NO_PATTERN_TO_TEST)});
            return;
        }

        try {
            const regex = new RegExp(data.regEx);
            const matches = regex.test(testValue);
            setTestResult({
                valid: matches,
                message: matches ? t(DataTypeTranslationKey.PATTERN_MATCHES) : t(DataTypeTranslationKey.PATTERN_DOES_NOT_MATCH)
            });
        } catch (e) {
            setTestResult({
                valid: false,
                message: t(DataTypeTranslationKey.REGULAR_EXPRESSION_IS_INVALID)
            });
        }
    }

    let testResultIcon: JSX.Element;
    if (!testResult) {
        testResultIcon = <HelpOutline color={"disabled"}/>;
    } else if (testResult.valid) {
        testResultIcon = <CheckCircle color={"success"}/>;
    } else {
        testResultIcon = <Cancel color={"error"}/>;
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <TextField
                        label={t(DataTypeTranslationKey.REGULAR_EXPRESSION_PATTERN)}
                        value={data.regEx}
                        onChange={(value) => onPatternChange(value)}
                        errorMessage={errors?.regEx ? t(errors.regEx) : undefined}
                        helperText={t(DataTypeTranslationKey.ENTER_VALID_REGULAR_EXPRESSION_PATTERN)}
                        fullWidth/>
            </Grid>
            <Grid item xs></Grid>
            <Grid item xs={10}>
                <TextField
                        label={t(DataTypeTranslationKey.TEST_VALUE)}
                        value={testValue}
                        onChange={onTestValueChange}
                        errorMessage={testResult && !testResult.valid ? t(testResult.message) : undefined}
                        helperText={testResult?.valid ? testResult.message : undefined}
                        InputProps={{
                            endAdornment: <InputAdornment position={"end"}>{testResultIcon}</InputAdornment>
                        }}
                        fullWidth/>
            </Grid>
            <Grid item xs={"auto"}>
                <TooltippedIconButton
                        tooltip={t(DataTypeTranslationKey.TEST_PATTERN)}
                        icon={<PlayCircle/> }
                        color={"primary"}
                        onClick={testPattern}
                        size={"medium"}
                        disabled={testResult !== null}/>
            </Grid>
        </Grid>
    );
}